


import React, { useEffect, useState } from 'react';
import styles from '../../../src/assets/scss/CreateOrders.module.scss';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Pagination from '../../Components/Common/Pagination';
import {
    useCreateOrderMutation,
    useGetMyEmployeesQuery,
    useGetMyVendorsQuery,
    useGetOrderByIdQuery,
    useGetUserByIdQuery,
    useMoveToBillingMutation,
    useUpdateOrderMutation
} from '../../slices/admin/admin';
import DeleteConfirmModal from '../../Components/Common/DeleteConfirmModal';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { getUserInfo } from '../../utils/user.util';
import { toast } from 'react-toastify';
import Select from 'react-select';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import ApprovePopup from './ApprovePopup';
import DeleteConfirmModalLogout from '../../Components/Common/DeleteConfirmModalLogout';

const ApproveOrders = () => {
    const [effectiveDate, setEffectiveDate] = useState('');

    const [orderId, setOrderId] = useState(null);
    const [selectedStore, setSelectedStore] = useState('');
    const [selectedVendorId, setSelectedVendorId] = useState('');
    const [orderItems, setOrderItems] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [deliveryOption, setDeliveryOption] = useState('');
    const [assignedTo, setAssignedTo] = useState('');

    const [showAddItemPopup, setShowAddItemPopup] = useState(false);
    const [popupProps, setPopupProps] = useState(null);



    const { data: empData } = useGetMyEmployeesQuery();
    const employees = empData?.result || [];
    // console.log(employees, "employees");

    const navigate = useNavigate();
    const location = useLocation();
    const viewOnly = location.state?.viewOnly || false;
    const orderIdToView = location.state?.orderId || null;

    // console.log(orderIdToView, "orderIdToView");


    const [moveToBilling] = useMoveToBillingMutation();

    const isUpdateMode = location.state?.updateMode || false;

    const [createOrder, { isLoading: isCreating }] = useCreateOrderMutation();
    const [updateOrder, { isLoading: isUpdating }] = useUpdateOrderMutation();
    const { data, isLoading: isVendorsLoading } = useGetMyVendorsQuery();
    const stores = data?.stores || [];

    const { data: viewOrderData, refetch: refetchOrder } = useGetOrderByIdQuery(orderIdToView, {
        skip: !orderIdToView || (!viewOnly && !isUpdateMode),
        refetchOnMountOrArgChange: true
    });

    useEffect(() => {
        // Log once when component mounts
        if (orderIdToView) {
            console.log(orderIdToView, "orderIdToView888");
        }
    }, [orderIdToView]);

    useEffect(() => {
        const loadOrderData = () => {
            if ((viewOnly || isUpdateMode) && orderIdToView && viewOrderData?.result?.[0]) {
                const order = viewOrderData.result[0];

                // AssignedTo
                setAssignedTo(order.assignedTo || '');

                // Set store details
                const matchedStoreId = order.store?._id || order.orderStore;
                if (matchedStoreId) {
                    setSelectedStore(matchedStoreId);
                    setSelectedVendorId(matchedStoreId);
                } else {
                    toast.warn('Order store not found in vendor list');
                    setSelectedStore('');
                    setSelectedVendorId('');
                }

                // Preorder date
                setEffectiveDate(dayjs(order.date || order.preOrderDate).format('YYYY-MM-DD'));

                setOrderId(order._id || null);

                // Items

                const formattedItems = order.items?.map(item => {
                    const bag = item.productBag || '';

                    return {
                        itemId: item._id,
                        itemName: item.productName || '',
                        productBag: bag,
                        productType: item.productType || '',
                        productQuantity: bag === 'kilogram' ? item.productQuantity || 0 : 0,
                        productCount: bag !== 'kilogram' ? item.productCount || 0 : 0,
                        overallQuantity: item?.overallQuantity || 0,
                    };
                }) || [];


                setOrderItems(formattedItems);
            }
        };

        loadOrderData();
    }, [viewOrderData, orderIdToView, viewOnly, isUpdateMode]);

    useEffect(() => {
        if (selectedStore && stores.length > 0) {
            const vendor = stores.find(store => store._id === selectedStore);
            setSelectedVendorId(vendor ? vendor._id : '');
        }
    }, [selectedStore, stores]);

    useEffect(() => {
        if (!viewOnly && !isUpdateMode) {
            const storedStore = localStorage.getItem('selectedStore');
            const storedDate = localStorage.getItem('selectedDate');
            if (storedStore) setSelectedStore(storedStore);
            if (storedDate) setEffectiveDate(storedDate);
            const storedItems = JSON.parse(localStorage.getItem('orderItems') || '[]');
            setOrderItems(storedItems);
        }
    }, [viewOnly, isUpdateMode]);

    const user = getUserInfo();
    const userId = user?._id;
    const { data: profileData } = useGetUserByIdQuery(userId, { skip: !userId });
    const [userData, setUserData] = useState(null);






    useEffect(() => {
        if ((viewOnly || isUpdateMode) && viewOrderData?.result?.[0]) {
            const order = viewOrderData.result[0];
            setUserData({
                firstName: order.createdBy?.firstName || '',
                lastName: order.createdBy?.lastName || '',
                phone: order.createdBy?.phone || '',
                address: order.store?.address || 'N/A'
            });
        } else if (profileData?.result) {
            setUserData({
                firstName: profileData.result[0]?.firstName || '',
                lastName: profileData.result[0]?.lastName || '',
                phone: profileData.result[0]?.phone || '',
                address: profileData.result[0]?.store?.address || 'N/A'
            });
        }
    }, [viewOnly, isUpdateMode, viewOrderData, profileData]);



    const handleAddItem = () => {
        if (!selectedVendorId) {
            toast.error('Please select a store first');
            return;
        }

        localStorage.setItem('selectedStore', selectedStore);
        localStorage.setItem('selectedDate', effectiveDate);

        setPopupProps({
            storeId: selectedVendorId,
            updateMode: isUpdateMode,
            viewOnly,
            orderId: orderIdToView,
        });
        setShowAddItemPopup(true);
    };




    // new code snippet

    const ITEMS_PER_PAGE = 10;

    const [approvedItems, setApprovedItems] = useState([]);
    const [currentPages, setCurrentPages] = useState(1);

    console.log(approvedItems,"approvedItems");
    

    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);


    // const loadApprovedItems = () => {
    //     const storedItems = JSON.parse(localStorage.getItem("approvedItems") || "[]");
    //     if (Array.isArray(storedItems)) {
    //         setApprovedItems(storedItems.filter(Boolean));
    //     }
    // };

    const loadApprovedItems = () => {
        const storedItems = JSON.parse(localStorage.getItem("approvedItems") || "[]");
        const cleanedItems = storedItems.filter(item => item && item.itemId && item.billingItemId); // extra check
        setApprovedItems(cleanedItems);
    };


    useEffect(() => {
        loadApprovedItems();
    }, []);

    const flattenedItems = approvedItems.flatMap((item) => {
        if (!item) return [];

        const bagWeight = item.bagType?.match(/\d+/)?.[0] || "-";

        return {
            itemId: item.itemId || "-",
            itemName: item.itemName || "-",
            productBag: item.bagType || "-",
            itemBag: item.itemBag || "-",
            productType: item.productType || "-",
            productQuantity: item.quantityKg || "-",
            productCount: item.count || "-",
            overallQuantity: item.overallQuantity || "-",
            billingLabel: `Item ID ${item.itemId || "-"} - ${item.itemName || "-"} - ${item.qty || 0} kg`,
            billingQuantity: item.qty || "-",
            billingItemId: item.billingItemId || "-",
        };
    });

    console.log(flattenedItems,"flattenedItems");
    

    const totalPagess = Math.ceil(flattenedItems.length / ITEMS_PER_PAGE);

    const handlePageChanges = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPages(page);
        }
    };

    const paginatedItemss = flattenedItems.slice(
        (currentPages - 1) * ITEMS_PER_PAGE,
        currentPages * ITEMS_PER_PAGE
    );

    const handleEditItems = (index) => {
        const globalIndex = (currentPages - 1) * ITEMS_PER_PAGE + index;
        const itemToEdit = flattenedItems[globalIndex];

        if (!itemToEdit) {
            toast.error("Invalid item selected for editing.");
            return;
        }

        const storedItems = JSON.parse(localStorage.getItem("approvedItems") || "[]");
        const mainIndex = storedItems.findIndex(item =>
            item && item.billingItemId === itemToEdit.billingItemId
        );

        if (mainIndex === -1) {
            toast.error("Item not found in localStorage for editing");
            return;
        }

        const saved = storedItems[mainIndex];

        setPopupProps({
            editIndex: mainIndex,
            itemData: {
                itemId: saved.itemId || '',
                itemName: saved.itemName || '',
                productBag: saved.bagType || '',
                productQuantity: saved.quantityKg || '',
                productCount: saved.count || '',
                productType: saved.productType || '',
                overallQuantity: saved.overallQuantity || 0,
                addedBillingItems: [
                    {
                        billingItemId: saved.billingItemId,
                        billingItemQuantity: saved.qty,
                    }
                ]
            }
        });

        setShowAddItemPopup(true);
    };


    const handleDeleteItem = (index) => {
        setDeleteIndex(index);
        setDeleteConfirmOpen(true);
    };

    const confirmDeleteItem = () => {
        if (deleteIndex !== null) {
            const globalIndex = (currentPages - 1) * ITEMS_PER_PAGE + deleteIndex;
            const itemToDelete = flattenedItems[globalIndex];

            if (!itemToDelete) {
                console.warn("Item to delete is null or undefined");
                setDeleteConfirmOpen(false);
                return;
            }

            const storedItems = JSON.parse(localStorage.getItem("approvedItems") || "[]");

            const updatedItems = storedItems.filter(item =>
                item.billingItemId !== itemToDelete.billingItemId
            );

            localStorage.setItem("approvedItems", JSON.stringify(updatedItems));
            setApprovedItems(updatedItems);
            toast.success("Item deleted successfully");
        }

        setDeleteIndex(null);
        setDeleteConfirmOpen(false);
    };


    const handlePopupClose = () => {
        setShowAddItemPopup(false);
        loadApprovedItems();
    };


    const [confirmMoveOpen, setConfirmMoveOpen] = useState(false);

    const handleMoveToBilling = async () => {
        try {
            const approvedItems = JSON.parse(localStorage.getItem("approvedItems") || "[]");

            const billingItems = approvedItems
                .filter(item => item.billingItemId && item.itemId && item.itemName && item.qty)
                .map(item => ({
                    orderItemId: item.itemId,
                    itemId: item.billingItemId,
                    productName: item.itemName,
                    productQuantity: Number(item.qty),
                }));

            if (billingItems.length === 0) {
                toast.error("Please Assign Items No valid billing items found.");
                return;
            }

            const payload = {
                orderId: orderIdToView,
                billingItems,
            };

            const response = await moveToBilling(payload).unwrap();

            toast.success("Billing moved successfully!");
            navigate("/dashboard/Ordertable");
            localStorage.removeItem("approvedItems");
        } catch (err) {
            toast.error(err?.data?.message || err?.message || "Failed to move to billing.");
        }
    };

    const handleMoveClick = () => {
        setConfirmMoveOpen(true);
    };

    const confirmMoveToBilling = () => {
        setConfirmMoveOpen(false);
        handleMoveToBilling();
    };



    //new code end 


    const handleQuantityChange = (index, field, value) => {
        const updatedItems = [...orderItems];
        updatedItems[index][field] = value;
        setOrderItems(updatedItems);

        if (!viewOnly && !orderIdToView) {
            localStorage.setItem('orderItems', JSON.stringify(updatedItems));
        }
    };


    const handleDelete = (index) => {
        setSelectedDeleteIndex(index);
        setModalOpen(true);
    };

    const confirmDelete = () => {
        if (selectedDeleteIndex !== null) {
            const updatedItems = [...orderItems];
            updatedItems.splice(selectedDeleteIndex, 1);
            setOrderItems(updatedItems);
            localStorage.setItem('orderItems', JSON.stringify(updatedItems));
            setSelectedDeleteIndex(null);
            setModalOpen(false);
        }
    };

    const itemsPerPage = 10;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedItems = orderItems.slice(startIndex, startIndex + itemsPerPage);
    const totalPages = Math.ceil(orderItems.length / itemsPerPage);
    const handlePageChange = (page) => setCurrentPage(page);

    const handleClose = () => {
        localStorage.removeItem('tempApproveOrderItems');
        localStorage.removeItem('approvedItems');
        localStorage.removeItem('orderItems');
        navigate('/dashboard/Ordertable');
    };





    // const handleMoveToBilling = async () => {
    //     try {
    //         //const token = localStorage.getItem("token");
    //         const approvedItems = JSON.parse(localStorage.getItem("approvedItems") || "[]");

    //         // if (!token) {
    //         //     toast.error("Missing auth token.");
    //         //     return;
    //         // }

    //         // if (!orderId) {
    //         //     toast.error("Order ID missing.");
    //         //     return;
    //         // }

    //         // if (!Array.isArray(approvedItems) || approvedItems.length === 0) {
    //         //     toast.error("No approved items found.");
    //         //     return;
    //         // }

    //         const billingItems = approvedItems
    //             .filter(item => item.billingItemId && item.itemId && item.itemName && item.qty)
    //             .map(item => ({
    //                 orderItemId: item.itemId,
    //                 itemId: item.billingItemId,
    //                 productName: item.itemName,
    //                 productQuantity: Number(item.qty),
    //             }));

    //         if (billingItems.length === 0) {
    //             toast.error("Please Assign Items No valid billing items found.");
    //             return;
    //         }

    //         const payload = {
    //             orderId: orderIdToView,
    //             billingItems,
    //         };

    //         const response = await moveToBilling(payload).unwrap();

    //         toast.success("Billing moved successfully!");
    //         navigate("/dashboard/Ordertable");
    //         localStorage.removeItem("approvedItems");
    //     } catch (err) {
    //         toast.error(err?.data?.message || err?.message || "Failed to move to billing.");
    //     }
    // };



    const handleEditItem = (index) => {
        const item = orderItems[index];
        if (!item?.itemId && isUpdateMode) {
            toast.error('Item ID missing');
            return;
        }

        setPopupProps({
            editIndex: undefined,
            itemData: item,
            storeId: selectedVendorId,
            orderId: orderIdToView,
        });
        setShowAddItemPopup(true);
    };



    const storeOptions = stores.map(store => ({
        value: store._id,
        label: `${store.storeName}`
    }));

    return (
        <div className={styles.createOrdersContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>{viewOnly ? 'Approve Order' : isUpdateMode ? 'Update Order' : 'Create Orders'}</h2>
                <span className={styles.closeIcon} onClick={handleClose}>✕</span>
            </div>

            <div className={styles.container}>
                <div className={styles.formSection}>
                    <div className={styles.formLeft}>
                        {!(viewOnly || isUpdateMode) && (
                            <>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Order Placed To</label>
                                    <div className={styles.selectWrapper}>
                                        <Select
                                            className={styles.customSelect}
                                            isDisabled={viewOnly}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    border: '1px solid #6D6D6D',
                                                    borderRadius: '6px',
                                                    fontSize: '16px',
                                                    minHeight: '50px',
                                                    boxShadow: 'none',
                                                    color: 'black',
                                                    fontWeight: '600',
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    color: '#6D6D6D',
                                                    fontSize: '16px',
                                                    fontWeight: '600',
                                                }),
                                            }}
                                            value={storeOptions.find(option => option.value === selectedStore) || null}
                                            onChange={(selectedOption) => setSelectedStore(selectedOption?.value)}
                                            options={storeOptions}
                                            placeholder="Select Store"
                                            isSearchable
                                        />
                                    </div>
                                </div>

                                {/* <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Order Status</label>
                                    <select className={styles.inputs} disabled>
                                        <option>Pending</option>
                                    </select>
                                </div> */}
                            </>
                        )}

                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Pre Order Date</label>
                            <DatePicker
                                disabled={viewOnly}
                                selected={effectiveDate ? dayjs(effectiveDate, 'YYYY-MM-DD').toDate() : null}
                                onChange={(date) => setEffectiveDate(dayjs(date).format('YYYY-MM-DD'))}
                                dateFormat="MM.dd.yyyy"
                                minDate={new Date()}
                                placeholderText="Select date"
                                className={styles.input}
                                wrapperClassName={styles.fullWidthDatepicker}
                            />
                        </div>



                        {(isUpdateMode || viewOnly) && user?.type !== 'employee' && (
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Assigned To</label>
                                <select
                                    className={styles.inputs}
                                    value={assignedTo}
                                    onChange={(e) => setAssignedTo(e.target.value)}
                                    disabled={viewOnly}
                                >
                                    <option value="">Select Employee</option>
                                    {employees.map(emp => (
                                        <option key={emp._id} value={emp._id}>
                                            {emp.userName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}



                        {!viewOnly && !isUpdateMode && (
                            <div className={styles.inputGroup}>
                                <label className={styles.inputLabel}>Delivery Option</label>
                                <select
                                    className={styles.inputs}
                                    value={deliveryOption}
                                    onChange={(e) => setDeliveryOption(e.target.value)}
                                    required
                                >
                                    <option value="">Select Delivery Option</option>
                                    <option value="pickup">Own delivery pickup</option>
                                    <option value="shipping">Send by store</option>
                                    <option value="third-party logistics">Third-Party Logistics</option>
                                </select>
                            </div>
                        )}
                    </div>

                    <div className={styles.formRight}>
                        <p><strong>Order From</strong></p>
                        <p><strong>Item Owner:</strong> {userData?.firstName} {userData?.lastName}</p>
                        <p><strong>Address:</strong> {userData?.address}</p>
                        <p><strong>Phone No:</strong> {userData?.phone}</p>
                    </div>
                </div>

                <div className={styles.tableHeader}>
                    {!viewOnly && (
                        <button className={styles.addBtn} onClick={handleAddItem}>+ Add Item</button>
                    )}
                </div>



                <div className={styles.tableSection}>
                    <table>
                        <thead>
                            <tr>

                                <th>Order Seq No</th>
                                <th>Item Category</th>
                                <th>Item Scales</th>
                                <th>Product Type</th>
                                <th>Item Quantity(Kg)</th>
                                <th>Item Count</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedItems.length === 0 ? (
                                <tr><td colSpan={8}>No items added</td></tr>
                            ) : (
                                paginatedItems.map((item, index) => (
                                    <tr key={index}>

                                        <td>{startIndex + index + 1}</td>
                                        <td>{item.itemName}</td>
                                        <td>{item.productBag}</td>
                                        <td>{item.productType}</td>



                                        <td>
                                            {item.productBag === 'kilogram' ? (
                                                viewOnly ? (
                                                    item.productQuantity ?? '-'
                                                ) : (
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className={styles.tableInput}
                                                        value={item.productQuantity}
                                                        onChange={(e) =>
                                                            handleQuantityChange(startIndex + index, 'productQuantity', e.target.value)
                                                        }
                                                    />
                                                )
                                            ) : (
                                                '-'
                                            )}
                                        </td>

                                        <td>
                                            {item.productBag !== 'kilogram' ? (
                                                viewOnly ? (
                                                    item.productCount ?? '-'
                                                ) : (
                                                    <input
                                                        type="number"
                                                        min="0"
                                                        className={styles.tableInput}
                                                        value={item.productCount}
                                                        onChange={(e) =>
                                                            handleQuantityChange(startIndex + index, 'productCount', e.target.value)
                                                        }
                                                    />
                                                )
                                            ) : (
                                                '-'
                                            )}
                                        </td>



                                        <td className={styles.actions}>

                                            <button
                                                className={styles.save}
                                                title="Edit"
                                                onClick={() => handleEditItem(startIndex + index)}
                                            >
                                                Assign Items ID
                                            </button>

                                        </td>

                                    </tr>
                                ))
                            )}
                        </tbody>

                    </table>

                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>

                    <DeleteConfirmModal
                        isOpen={isModalOpen}
                        onClose={() => setModalOpen(false)}
                        onConfirm={confirmDelete}
                    />
                </div>

                <div className={styles.tableHeaders}>
                    <div className={styles.tableSection}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Seq No</th>
                                    <th>Item Name</th>
                                    <th>Bag Type</th>
                                    <th>Product Type</th>
                                    <th>Quantity (Kg)</th>
                                    <th>Count</th>
                                    <th>Overall Quantity</th>
                                    <th>Item Scales</th>
                                    <th>Qty</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedItemss.length > 0 ? (
                                    paginatedItemss.map((item, index) => (
                                        <tr key={index}>
                                            <td>{(currentPages - 1) * ITEMS_PER_PAGE + index + 1}</td>
                                            <td>{item.itemName}</td>
                                            <td>{item.productBag}</td>
                                            <td>{item.productType}</td>
                                            <td>{item.productQuantity}</td>
                                            <td>{item.productCount}</td>
                                            <td>{item.overallQuantity}</td>
                                            <td title={item.itemBag}>
                                                {item.itemBag || `Item ID ${item.itemId || '-'} - ${item.itemName || '-'} - ${item.qty || 0} x ${item.bagType || '-'}kg`}
                                            </td>

                                            <td>{item.billingQuantity}</td>
                                            <td >
                                                <div className={styles.actions}>
                                                    {/* <FaEdit
                                                        className={styles.icon}
                                                        title="Edit"
                                                        onClick={() => handleEditItems(index)}
                                                    /> */}
                                                    <FaTrash
                                                        className={styles.icon}
                                                        title="Delete"
                                                        onClick={() => handleDeleteItem(index)}
                                                    />
                                                </div>

                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="10" className={styles.noData}>
                                            No items found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        <div className={styles.paginationWrapper}>
                            <Pagination
                                currentPage={currentPages}
                                totalPages={totalPagess}
                                onPageChange={handlePageChanges}
                            />
                        </div>
                    </div>
                </div>




                <div className={styles.footerButtons}>
                    <button className={styles.cancel} onClick={handleClose}>Cancel</button>
                    {/* <button className={styles.save} onClick={handleMoveToBilling} disabled={isCreating || isUpdating}>
                        {isCreating || isUpdating ? 'Saving...' : isUpdateMode ? 'Update' : 'Save'}
                    </button> */}
                    <button
                        className={styles.saves}
                        onClick={handleMoveClick}
                        disabled={isCreating || isUpdating}
                    >
                        {isCreating || isUpdating ? "Saving..." : "Move to  Sales Billing"}
                    </button>
                </div>
            </div>
            {/* {showAddItemPopup && (
                <PopupWrapper onClose={() => setShowAddItemPopup(false)}>

                    <ApprovePopup
                        popupMode={true}
                        closePopup={() => setShowAddItemPopup(false)}
                        passedState={popupProps}
                        onItemUpdate={() => {
                            if (isUpdateMode) {
                                loadExtraOrderItems();
                            } else {
                                const updated = JSON.parse(localStorage.getItem('tempApproveOrderItems') || '[]');
                                setExtraOrderItems(updated);
                            }
                        }}
                    />
                </PopupWrapper>
            )} */}

            {showAddItemPopup && (
                <PopupWrapper onClose={handlePopupClose}>
                    <ApprovePopup
                        closePopup={handlePopupClose}
                        {...popupProps}
                    />
                </PopupWrapper>

            )}

            <DeleteConfirmModalLogout
                isOpen={deleteConfirmOpen}
                onConfirm={confirmDeleteItem}
                onCancel={() => {
                    setDeleteIndex(null);
                    setDeleteConfirmOpen(false);
                }}
                title="Are You Sure?"
                heading="Delete Confirmation"
                content="Do you really want to delete this item? This action cannot be undone."
            />

            <DeleteConfirmModalLogout
                isOpen={confirmMoveOpen}
                onConfirm={confirmMoveToBilling}
                onCancel={() => setConfirmMoveOpen(false)}
                title="Are You Sure?"
                heading="Move to Sales Billing Confirmation"
                content="Do you really want to move these items to billing? This action cannot be undone."
            />

        </div>
    );
};

export default ApproveOrders;








